export default "__VITE_ASSET__8f33c87f__"